import React from 'react'
import TextField from 'material-ui/TextField'

export default ({ input, className, meta: { touched, active, error }, ...rest }) => (
  <div className="form-group-mui">
    <TextField
      fullWidth
      error={!!error}
      helperText={error}
      {...input}
      {...rest}
      onBlur={() => input.onBlur(input.value)}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/group.js